import { useState, useCallback } from "react";

const STORAGE_PREFIX = "dateFilter:";

function read(screenKey) {
  try {
    const raw = sessionStorage.getItem(STORAGE_PREFIX + screenKey);
    return raw ? JSON.parse(raw) : { fromDate: "", toDate: "" };
  } catch {
    return { fromDate: "", toDate: "" };
  }
}

function write(screenKey, fromDate, toDate) {
  sessionStorage.setItem(
    STORAGE_PREFIX + screenKey,
    JSON.stringify({ fromDate, toDate })
  );
}

export function useDateFilter(screenKey, defaults = {}) {
  const [dates, setDates] = useState(() => {
    const stored = read(screenKey);
    return {
      fromDate: stored.fromDate || defaults.fromDate || "",
      toDate: stored.toDate || defaults.toDate || "",
    };
  });

  const setFromDate = useCallback(
    (fromDate) => {
      setDates((prev) => {
        const next = { ...prev, fromDate };
        write(screenKey, next.fromDate, next.toDate);
        return next;
      });
    },
    [screenKey]
  );

  const setToDate = useCallback(
    (toDate) => {
      setDates((prev) => {
        const next = { ...prev, toDate };
        write(screenKey, next.fromDate, next.toDate);
        return next;
      });
    },
    [screenKey]
  );

  const setBothDates = useCallback(
    (fromDate, toDate) => {
      write(screenKey, fromDate, toDate);
      setDates({ fromDate, toDate });
    },
    [screenKey]
  );

  const clearDates = useCallback(() => {
    sessionStorage.removeItem(STORAGE_PREFIX + screenKey);
    setDates({ fromDate: "", toDate: "" });
  }, [screenKey]);

  return {
    fromDate: dates.fromDate,
    toDate: dates.toDate,
    setFromDate,
    setToDate,
    setBothDates,
    clearDates,
  };
}